// Action Types

export const Types = {
  LIST_PROJECTS_REQUESTED: 'technicalDep/LIST_PROJECTS_REQUESTED',
  LIST_PROJECTS_SUCCEEDED: 'technicalDep/LIST_PROJECTS_SUCCEEDED',
  LIST_PROJECTS_FAILED: 'technicalDep/LIST_PROJECTS_FAILED',

  LIST_OPPROJECTS_REQUESTED: 'technicalDep/LIST_OPPROJECTS_REQUESTED',
  LIST_OPPROJECTS_SUCCEEDED: 'technicalDep/LIST_OPPROJECTS_SUCCEEDED',
  LIST_OPPROJECTS_FAILED: 'technicalDep/LIST_OPPROJECTS_FAILED',

  GET_PROJECT_REQUESTED: 'technicalDep/GET_PROJECT_REQUESTED',
  GET_PROJECT_SUCCEEDED: 'technicalDep/GET_PROJECT_SUCCEEDED',
  GET_PROJECT_FAILED: 'technicalDep/GET_PROJECT_FAILED',

  GET_OPPROJECT_REQUESTED: 'technicalDep/GET_OPPROJECT_REQUESTED',
  GET_OPPROJECT_SUCCEEDED: 'technicalDep/GET_OPPROJECT_SUCCEEDED',
  GET_OPPROJECT_FAILED: 'technicalDep/GET_OPPROJECT_FAILED',

  GET_PRODUCTS_REQUESTED: 'technicalDep/GET_PRODUCTS_REQUESTED',
  GET_PRODUCTS_SUCCEEDED: 'technicalDep/GET_PRODUCTS_SUCCEEDED',
  GET_PRODUCTS_FAILED: 'technicalDep/GET_PRODUCTS_FAILED',

  GET_PROJECT_PRODUCTS_REQUESTED: 'technicalDep/GET_PROJECT_PRODUCTS_REQUESTED',
  GET_PROJECT_PRODUCTS_SUCCEEDED: 'technicalDep/GET_PROJECT_PRODUCTS_SUCCEEDED',
  GET_PROJECT_PRODUCTS_FAILED: 'technicalDep/GET_PROJECT_PRODUCTS_FAILED',

  GET_PRODUCT_FILES_REQUESTED: 'technicalDep/GET_PRODUCT_FILES_REQUESTED',
  GET_PRODUCT_FILES_SUCCEEDED: 'technicalDep/GET_PRODUCT_FILES_SUCCEEDED',
  GET_PRODUCT_FILES_FAILED: 'technicalDep/GET_PRODUCT_FILES_FAILED',

  GET_TEAM_REQUESTED: 'technicalDep/GET_TEAM_REQUESTED',
  GET_TEAM_SUCCEEDED: 'technicalDep/GET_TEAM_SUCCEEDED',
  GET_TEAM_FAILED: 'technicalDep/GET_TEAM_FAILED',

  GET_PROJECT_TEAM_REQUESTED: 'technicalDep/GET_PROJECT_TEAM_REQUESTED',
  GET_PROJECT_TEAM_SUCCEEDED: 'technicalDep/GET_PROJECT_TEAM_SUCCEEDED',
  GET_PROJECT_TEAM_FAILED: 'technicalDep/GET_PROJECT_TEAM_FAILED',

  GET_PROJECT_CONTRACT_REQUESTED: 'technicalDep/GET_PROJECT_CONTRACT_REQUESTED',
  GET_PROJECT_CONTRACT_SUCCEEDED: 'technicalDep/GET_PROJECT_CONTRACT_SUCCEEDED',
  GET_PROJECT_CONTRACT_FAILED: 'technicalDep/GET_PROJECT_CONTRACT_FAILED',

  GET_ATIVTP_REQUESTED: 'technicalDep/GET_ATIVTP_REQUESTED',
  GET_ATIVTP_SUCCEEDED: 'technicalDep/GET_ATIVTP_SUCCEEDED',
  GET_ATIVTP_FAILED: 'technicalDep/GET_ATIVTP_FAILED',

  GET_ATIV_PRODUCTS_REQUESTED: 'technicalDep/GET_ATIV_PRODUCTS_REQUESTED',
  GET_ATIV_PRODUCTS_SUCCEEDED: 'technicalDep/GET_ATIV_PRODUCTS_SUCCEEDED',
  GET_ATIV_PRODUCTS_FAILED: 'technicalDep/GET_ATIV_PRODUCTS_FAILED',

  GET_AVAL_REQUESTED: 'technicalDep/GET_AVAL_REQUESTED',
  GET_AVAL_SUCCEEDED: 'technicalDep/GET_AVAL_SUCCEEDED',
  GET_AVAL_FAILED: 'technicalDep/GET_AVAL_FAILED',

  GET_APROV_REQUESTED: 'technicalDep/GET_APROV_REQUESTED',
  GET_APROV_SUCCEEDED: 'technicalDep/GET_APROV_SUCCEEDED',
  GET_APROV_FAILED: 'technicalDep/GET_APROV_FAILED',

  GET_PRODUCTS_FROM_OIKOS_REQUESTED: 'technicalDep/GET_PRODUCTS_FROM_OIKOS_REQUESTED',
  GET_PRODUCTS_FROM_OIKOS_SUCCEEDED: 'technicalDep/GET_PRODUCTS_FROM_OIKOS_SUCCEEDED',
  GET_PRODUCTS_FROM_OIKOS_FAILED: 'technicalDep/GET_PRODUCTS_FROM_OIKOS_FAILED',

}

// Action Creators

export function listProjects(user) {
  return {
    type: Types.LIST_PROJECTS_REQUESTED,
    payload: user
  }
}

export function listOpProjects() {
  return {
    type: Types.LIST_OPPROJECTS_REQUESTED,
  }
}

export function getProject(projectId) {
  return {
    type: Types.GET_PROJECT_REQUESTED,
    payload: projectId,
  }
}

export function getOpProject(projectId) {
  return {
    type: Types.GET_OPPROJECT_REQUESTED,
    payload: projectId,
  }
}

export function getProducts() {
  return {
    type: Types.GET_PRODUCTS_REQUESTED,
  }
}

export function getProjectProducts(projectId) {
  return {
    type: Types.GET_PROJECT_PRODUCTS_REQUESTED,
    payload: projectId,
  }
}

export function getProductFiles(productId) {
  return {
    type: Types.GET_PRODUCT_FILES_REQUESTED,
    payload: productId,
  }
}

export function getTeam() {
  return {
    type: Types.GET_TEAM_REQUESTED,
  }
}

export function getProjectTeam(projectId) {
  return {
    type: Types.GET_PROJECT_TEAM_REQUESTED,
    payload: projectId,
  }
}

export function getProjectContract(contractId) {
  return {
    type: Types.GET_PROJECT_CONTRACT_REQUESTED,
    payload: contractId,
  }
}

export function getAtivTp() {
  return {
    type: Types.GET_ATIVTP_REQUESTED,
  }
}

export function getAtivProducts(prodId) {
  return {
    type: Types.GET_ATIV_PRODUCTS_REQUESTED,
    payload: prodId,
  }
}

export function getProductsFromOikos() {
  return {
    type: Types.GET_PRODUCTS_FROM_OIKOS_REQUESTED,
  }
}

export function getAval() {
  return {
    type: Types.GET_AVAL_REQUESTED,
  }
}
export function getAprov() {
  return {
    type: Types.GET_APROV_REQUESTED,
  }
}

// Reducer

const INITIAL_STATE = {
  listOpProjectsIsLoading: false,
  listOpProjectsError: null,
  opProjects: null,

  listOpProjectIsLoading: false,
  listOpProjectError: null,
  opProject: null,

  listProjectsIsLoading: false,
  listProjectsError: null,
  projects: null,

  getProjectIsLoading: false,
  getProjectError: null,
  project: null,

  getProductsIsLoading: false,
  getProductsError: null,
  products: null,

  getProjectProductsIsLoading: false,
  getProjectProductsError: null,
  projectProducts: null,

  getProductFilesIsLoading: false,
  getProductFilesError: null,
  productFiles: null,

  getTeamIsLoading: false,
  getTeamError: null,
  team: null,

  getProjectTeamIsLoading: false,
  getProjectTeamError: null,
  projectTeam: null,

  getProjectContractIsLoading: false,
  getProjectContractError: null,
  projectContract: null,

  getAtivTpIsLoading: false,
  getAtivTpError: null,
  ativTp: null,

  getAtivProductsIsLoading: false,
  getAtivProductsError: null,
  ativProducts: null,

  getAvalIsLoading: false,
  getAvalTpError: null,
  aval: null,

  getAprovlIsLoading: false,
  getAprovTpError: null,
  aprov: null,

  getProductsFromOikosIsLoading: false,
  getProductsFromOikosError: null,
  productsFromOikos: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.LIST_PROJECTS_REQUESTED:
      return {
        ...state,
        listProjectsIsLoading: true,
      }
    case Types.LIST_PROJECTS_SUCCEEDED:
      return {
        ...state,
        listProjectsIsLoading: false,
        listProjectsError: null,
        projects: action.payload,
      }
    case Types.LIST_PROJECTS_FAILED:
      return {
        ...state,
        listProjectsIsLoading: false,
        listProjectsError: action.payload,
        projects: null,
      }

    case Types.LIST_OPPROJECTS_REQUESTED:
      return {
        ...state,
        listOpProjectsIsLoading: true,
      }
    case Types.LIST_OPPROJECTS_SUCCEEDED:
      return {
        ...state,
        listOpProjectsIsLoading: false,
        listOpProjectsError: null,
        opProjects: action.payload,
      }
    case Types.LIST_OPPROJECTS_FAILED:
      return {
        ...state,
        listOpProjectsIsLoading: false,
        listOpProjectsError: action.payload,
        opProjects: null,
      }

    case Types.GET_PROJECT_REQUESTED:
      return {
        ...state,
        getProjectIsLoading: true,
      }
    case Types.GET_PROJECT_SUCCEEDED:
      return {
        ...state,
        getProjectIsLoading: false,
        getProjectError: null,
        project: action.payload,
      }
    case Types.GET_PROJECT_FAILED:
      return {
        ...state,
        getProjectIsLoading: false,
        getProjectError: action.payload,
        project: null,
      }

    case Types.GET_OPPROJECT_REQUESTED:
      return {
        ...state,
        getOpProjectIsLoading: true,
      }
    case Types.GET_OPPROJECT_SUCCEEDED:
      return {
        ...state,
        getOpProjectIsLoading: false,
        getOpProjectError: null,
        opProject: action.payload,
      }
    case Types.GET_OPPROJECT_FAILED:
      return {
        ...state,
        getOpProjectIsLoading: false,
        getOpProjectError: action.payload,
        opProject: null,
      }

    case Types.GET_PRODUCTS_REQUESTED:
      return {
        ...state,
        getProductsIsLoading: true,
      }
    case Types.GET_PRODUCTS_SUCCEEDED:
      return {
        ...state,
        getProductsIsLoading: false,
        getProductsError: null,
        products: action.payload,
      }
    case Types.GET_PRODUCTS_FAILED:
      return {
        ...state,
        getProductsIsLoading: false,
        getProductsError: action.payload,
        products: null,
      }

    case Types.GET_PROJECT_PRODUCTS_REQUESTED:
      return {
        ...state,
        getProjectProductsIsLoading: true,
      }
    case Types.GET_PROJECT_PRODUCTS_SUCCEEDED:
      return {
        ...state,
        getProjectProductsIsLoading: false,
        getProjectProductsError: null,
        projectProducts: action.payload,
      }
    case Types.GET_PROJECT_PRODUCTS_FAILED:
      return {
        ...state,
        getProjectProductsIsLoading: false,
        getProjectProductsError: action.payload,
        projectProducts: null,
      }

    case Types.GET_PRODUCT_FILES_REQUESTED:
      return {
        ...state,
        getProductFilesIsLoading: true,
      }
    case Types.GET_PRODUCT_FILES_SUCCEEDED:
      return {
        ...state,
        getProductFilesIsLoading: false,
        getProductFilesError: null,
        productFiles: action.payload,
      }
    case Types.GET_PRODUCT_FILES_FAILED:
      return {
        ...state,
        getProductFilesIsLoading: false,
        getProductFilesError: action.payload,
        productFiles: null,
      }

    case Types.GET_TEAM_REQUESTED:
      return {
        ...state,
        getTeamIsLoading: true,
      }
    case Types.GET_TEAM_SUCCEEDED:
      return {
        ...state,
        getTeamIsLoading: false,
        getTeamError: null,
        team: action.payload,
      }
    case Types.GET_TEAM_FAILED:
      return {
        ...state,
        getTeamIsLoading: false,
        getTeamError: action.payload,
        team: null,
      }

    case Types.GET_PROJECT_TEAM_REQUESTED:
      return {
        ...state,
        getProjectTeamIsLoading: true,
      }
    case Types.GET_PROJECT_TEAM_SUCCEEDED:
      return {
        ...state,
        getProjectTeamIsLoading: false,
        getProjectTeamError: null,
        projectTeam: action.payload,
      }
    case Types.GET_PROJECT_TEAM_FAILED:
      return {
        ...state,
        getProjectTeamIsLoading: false,
        getProjectTeamError: action.payload,
        projectTeam: null,
      }

    case Types.GET_PROJECT_CONTRACT_REQUESTED:
      return {
        ...state,
        getContractIsLoading: true,
      }
    case Types.GET_PROJECT_CONTRACT_SUCCEEDED:
      return {
        ...state,
        getContractIsLoading: false,
        getContractError: null,
        projectContract: action.payload,
      }
    case Types.GET_PROJECT_CONTRACT_FAILED:
      return {
        ...state,
        getContractIsLoading: false,
        getContractError: action.payload,
        projectContract: null,
      }

    case Types.GET_ATIVTP_REQUESTED:
      return {
        ...state,
        getAtivTpIsLoading: true,
      }
    case Types.GET_ATIVTP_SUCCEEDED:
      return {
        ...state,
        getAtivTpIsLoading: false,
        getAtivTpError: null,
        ativTp: action.payload,
      }
    case Types.GET_ATIVTP_FAILED:
      return {
        ...state,
        getAtivTpIsLoading: false,
        getAtivTpError: action.payload,
        ativTp: null,
      }

    case Types.GET_ATIV_PRODUCTS_REQUESTED:
      return {
        ...state,
        getAtivProductsIsLoading: true,
      }
    case Types.GET_ATIV_PRODUCTS_SUCCEEDED:
      return {
        ...state,
        getAtivProductsIsLoading: false,
        getAtivProductsError: null,
        ativProducts: action.payload,
      }
    case Types.GET_ATIV_PRODUCTS_FAILED:
      return {
        ...state,
        getAtivProductsIsLoading: false,
        getAtivProductsError: action.payload,
        ativProducts: null,
      }
    case Types.GET_AVAL_REQUESTED:
      return {
        ...state,
        getAvalIsLoading: true,
      }

    case Types.GET_AVAL_SUCCEEDED:
      return {
        ...state,
        getAvalIsLoading: false,
        getAvalTpError: null,
        aval: action.payload,
      }

    case Types.GET_APROV_REQUESTED:
      return {
        ...state,
        getAprovIsLoading: true,
      }

    case Types.GET_APROV_SUCCEEDED:
      return {
        ...state,
        getAprovIsLoading: false,
        getAprovTpError: null,
        aprov: action.payload,
      }

      case Types.GET_PRODUCTS_FROM_OIKOS_REQUESTED:
        return {
          ...state,
          getProductsFromOikosIsLoading: true,
        }
      case Types.GET_PRODUCTS_FROM_OIKOS_SUCCEEDED:
        return {
          ...state,
          getProductsFromOikosIsLoading: false,
          getAtivProductsError: null,
          productsFromOikos: action.payload,
        }
      case Types.GET_PRODUCTS_FROM_OIKOS_FAILED:
        return {
          ...state,
          getProductsFromOikosIsLoading: false,
          getAtivProductsError: action.payload,
          productsFromOikos: null,
        }

    default:
      return state
  }
}
